<template>
    <div class="d-flex justify-space-between mb-4">
        <div class="text-body-2 medium">{{ label }}</div>
        <div class="text-body-2">{{ value }}</div>
    </div>
</template>

<script>
export default {
    name: 'AmortizationText',
    props: {
        label: {
            type: String,
        },
        value: {
            type: String,
        },
    },
    mixins: [],
    components: {},
    data() {
        return {}
    },
    computed: {},
    watch: {},
    methods: {},
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass"></style>
